// Copyright (c) 2018 Comsearch, Inc., All rights reserved

// projectSummary defines sorting for the paths summary table which it holds.
// this takes 'paths' which is a subset of the active project's paths,
// (these are filtered based on the projectSummry filtering)
// this then sorts the subset based on the sorting
// defined in projectSummary redux state.

const sortPaths = paths => (dispatch, getState) => {
  const { projectSummary } = getState()
  const asc = projectSummary.get('sortAsc')
  const col = projectSummary.get('sortCol')

  return paths.sort((a, b) => {
    const av = a.get(col)
    const bv = b.get(col)

    if (asc) {
      return (av >= bv) ? 1 : -1
    } else {
      return (av <= bv) ? 1 : -1
    }
  })
}

export default sortPaths
